class EventBus {
    constructor() {
        try {
            let eventTopics = {};
            let registeredEvents = [];
            this.addEventListener = function (eventName, listener, source) {
                let isUpdate = false;
                console.log("EventBus: Register to " + eventName + " - " + source);
                if (registeredEvents.length > 0 && registeredEvents.filter((r) => { return r.source === source && r.eventName === eventName; }).length > 0) {
                    console.log("EventBus: already registerd - update");
                    isUpdate = true;
                }

                if (!eventTopics[eventName] || eventTopics[eventName].length < 1 || isUpdate) {
                    eventTopics[eventName] = [];
                }

                eventTopics[eventName].push(listener);
                registeredEvents.push({ source, eventName });

            };
            this.emitEventListeners = function (eventName, params) {
                if (!eventTopics[eventName] || eventTopics[eventName].length < 1)
                    return;
                eventTopics[eventName].forEach(function (listener) {
                    listener(!!params ? params : {});
                });
            };
        }
        catch (error) {
            console.error(error);
        }
    }
}
//create the instance 
const _EventBus = new EventBus();
//export
export { _EventBus as EventBus };